import { render } from "./XTextButton.vue?vue&type=template&id=767173d0"
import script from "./XTextButton.vue?vue&type=script&lang=js"
export * from "./XTextButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.33_webpack@5.93.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__